import store from '@/store';

/**
 * 初始化 sessionStorage 中的业务信息
 * 用于单个标签页环境下的业务信息存储
 */
export function initSessionStorage() {
  // 从 sessionStorage 中获取业务信息
  var currBiz = sessionStorage.getItem('currBiz');
  var currBizCode = sessionStorage.getItem('currBizCode');
  var currBizName = sessionStorage.getItem('currBizName');

  // 如果 sessionStorage 中有业务信息，则更新 store
  if (currBiz) {
    store.commit('profile/SET_CURR_BIZ', parseInt(currBiz));
  }
  if (currBizCode) {
    store.commit('profile/SET_CURR_BIZ_CODE', currBizCode);
  }
  if (currBizName) {
    store.commit('profile/SET_CURR_BIZ_NAME', currBizName);
  }
  console.log('[SessionStorage] Initialized business information');
}